<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div id="compeSearchCase">
        <div class="flex">
          <h4 class="title">百度推广客服查询</h4>
          <el-input
            placeholder="请输入公司名称"
            v-model="BaiDuCompanyName"
            class="input-with-select"
            size="small"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="BaiDucompanySearch"
            ></el-button>
          </el-input>
        </div>
        <div class="border">
          <el-table :data="BaiDuCustomerList" style="width: 100%">
            <el-table-column
              prop="company_name"
              label="公司名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="account_id" label="账户ID" width="230">
            </el-table-column>
            <el-table-column prop="account_name" label="账户名称" width="230">
            </el-table-column>
            <el-table-column prop="customer_name" label="账户客服" width="230">
            </el-table-column>
            <el-table-column prop="division" label="中心/事业部" width="230">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script  >
import { getCustomer } from '../utils/request.js'
import { Loading } from 'element-ui'
export default {
  name: "BaiDucompanySearch",
  props: {},
  data() {
    return {
      BaiDuCompanyName: "",
      BaiDuCustomerList: [], //百度推广客服查询
    };
  },
  methods: {
    // 百度推广客服查询
    BaiDucompanySearch() {
      if (this.BaiDuCompanyName == "") {
        // this.$message({
        //   message: "请输入公司全称",
        //   duration: 1000,
        // });
        this.$alert('请输入公司全称', {
          confirmButtonText: '确定',
        });
      } else {
        this.BaiDuGetCustomer();
      }
    },
    // 百度推广客服查询
    BaiDuGetCustomer() {
      let params = {
        company_name: this.BaiDuCompanyName,
      };
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      getCustomer(params).then((res) => {
        if (res.status == 200) {
          this.BaiDuCustomerList = res.data.data;
          console.log(res.data.data, "推广客服查询");
          loadingInstance.close();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../assets/reset.less";
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  position: relative;
  padding-left: 15px;

  &::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 5px;
    background-color: @Color8;
    top: 50%;
    margin-top: -10px;
    left: 0px;
  }
}

.sear-div-line {
  display: flex;
  align-items: center;
  color: @Color10;
  font-size: 14px;

  .sear-total {
    color: @Color8;
    font-size: 24px;
    margin-left: 5px;

    i {
      font-size: 14px;
    }
  }
}

.industry-select-wrap {
  display: flex;
  align-items: center;
  color: @Color10;
  font-size: 14px;

  .com-div-wrap {
    .el-select {
      margin-left: 5px;
    }
  }
}


.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-pagination {
  text-align: right;
  margin: 10px 0px;
}

.download {
  font-size: 14px;
  color: @Color7;
}

.tabs {
  display: flex;
  align-items: center;

  .tab {
    border: 1px solid #eee;
    background-color: #f9f9f9;
    margin-right: 15px;
    width: 76px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #333;
    font-size: 14px;
    cursor: pointer;
  }

  .active {
    background-color: #fdb050;
    border: 1px solid #fdb050;
    color: #fff;
  }
}

.rank-h-title {
  display: block;
  font-size: 16px;
  color: @Color6;
  margin-bottom: 10px;
}

.calcLine {
  position: relative;
  top: -1px;
  margin-left: 2px;
  display: inline-block;
  height: 5px;
  background-color: #00d7db;
  vertical-align: middle;
}

/deep/.input-with-select {
  width: 40%;
}

.select {
  /deep/.el-input {
    width: 150px;
    margin-left: 10px;
  }
}

.border {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px;
  min-height: 145px;
}

h4.title {
  &::before {
    background-color: @Color6;
  }

  i {
    color: @Color8;
    font-size: 14px;
  }
}

</style>